import React from 'react';
import { createAccountControlsMobileLayoutClassName } from './accountControlsMobileLayoutStyles';
import { useOutsideClick } from 'hooks/useOutsideClick';

type LayoutProps = {
  email: React.ReactNode;
  signOutAction: React.ReactNode;
  onOutsideClick(): void;
};

export const AccountControlsMobileLayoutComponent = (props: LayoutProps) => {
  const { email, signOutAction, onOutsideClick } = props;

  const outsideClickRef = useOutsideClick<HTMLDivElement>(onOutsideClick);
  return (
    <div className={createAccountControlsMobileLayoutClassName('wrapper')}>
      <div
        ref={outsideClickRef}
        className={createAccountControlsMobileLayoutClassName('menu')}
      >
        <div
          className={createAccountControlsMobileLayoutClassName('emailSlot')}
        >
          {email}
        </div>
        <div
          className={createAccountControlsMobileLayoutClassName('actionSlot')}
        >
          {signOutAction}
        </div>
      </div>
    </div>
  );
};
